import * as _ from 'lodash';
import * as toastr from 'toastr';

import * as UserManagement from '../../';
import * as Common from '../../../../Common/modules';
import * as Models from '../../../../Models';
import * as Services from '../../../../Services';

export interface IEditPartnerScope {
  editPartnerCtrl: EditPartnerCtrl;
}

// tslint:disable-next-line: align
export class EditPartnerCtrl {
  private showLogging: boolean = false;
  private roleList: Models.Auth.RoleList.RoleList = new Models.Auth.RoleList.RoleList();
  public partner: Models.PartnerModel.IPartnerModel;
  public partnerGroups: Models.GroupModel.IGroupModel[];
  public partnerUsers: UserManagement.models.UserSearchResult.IUserSearchResult[];
  public isSaving = false;
  public alerts = <UserManagement.models.Alert.IAlert[]>[];

  public resultsHeaders: Common.IgsGrid.Igs.Common.IIgsGridHeader[] = [
    { name: "Username", property: "username" },
    { name: "Email Address", property: "emailAddress" },
    { name: "Name", property: "displayName" },
    { name: "Agent Code", property: "agentCode" },
    {
      name: "",
      blockSort: true,
      action: {
        name: "View",
        css: "btn btn-default cyan-btn",
        click: (value: any) => {
          this.$state.go("main.usermanagement.edituser", { id: value.userId });
        },
      },
    },
  ];

  public static $inject = [
    "$scope",
    "$stateParams",
    "$timeout",
    "$state",
    "igs.messageBox",
    "UserService",
    "GroupRetrievalService",
    "RoleRetrievalService",
    "UserRetrievalService",
    "PartnerRetrievalService",
    "PartnerSaveService",
  ];

  constructor(
    private $scope: IEditPartnerScope,
    private $stateParams: any,
    private $timeout: ng.ITimeoutService,
    private $state: angular.ui.IStateService,
    private messageBox: Common.MessageBox.Igs.Common.IIgsMessageBoxService,
    private userService: Services.UserService.IUserService,
    private groupRetrievalService: UserManagement.services.GroupRetrievalService.IGroupRetrievalService,
    private rollRetrievalService: UserManagement.services.RoleRetrivalService.IRoleRetrievalService,
    private userRetrievalService: UserManagement.services.UserRetrievalService.IUserRetrievalService,
    private partnerRetrievalService: UserManagement.services.PartnerRetrievalService.IPartnerRetrievalService,
    private partnerSaveService: UserManagement.services.PartnerSaveService.IPartnerSaveService,
  ) {
    $scope.editPartnerCtrl = this;
    // Only user admins can edit partners
    this.userService.isUserInRole(this.roleList.manageUsersAdmin).then((response) => {
      if (response === false) {
        this.$state.go("main.customersearchv2");
      }
    });

    this.getAndSetPartner()
      .then(() => this.getAndSetGroups())
      .then(() => this.getAndSetUsersInPartner());
  }

  public savePartner = () => {
    if (this.showLogging) {
      console.log("saving partner...");
    }
    this.isSaving = true;
    this.partnerSaveService
      .savePartner(this.partner)
      .then(
        () => {
          toastr.success("Success", "Partner saved successfully");
        },
        () => {
          toastr.error("Error", "There was a problem saving the partner");
        },
      )
      .finally(() => {
        this.isSaving = false;
      });
  };

  public getButtonClass = (group: Models.GroupModel.IGroupModel) => {
    return this.groupIsSelected(group) ? "cyan-btn" : "";
  };

  public groupIsSelected = (group: Models.GroupModel.IGroupModel) => {
    return this.partner && _.some(this.partner.groupIds, (id: string) => id === group.groupId);
  };

  private getAndSetPartner(): ng.IPromise<void> {
    if (this.showLogging) {
      console.log("setting partner...");
    }
    return this.partnerRetrievalService
      .getPartner(this.$stateParams.code)
      .then((partner: Models.PartnerModel.IPartnerModel) => {
        this.partner = partner;
      });
  }

  private getAndSetGroups(): ng.IPromise<void> {
    if (this.showLogging) {
      console.log("setting partner groups...");
    }
    return this.groupRetrievalService
      .getGroupsInPartner(this.$stateParams.code)
      .then((groups: Models.GroupModel.IGroupModel[]) => {
        this.partnerGroups = _.sortBy(groups, "name");
      });
  }

  private getAndSetUsersInPartner(): ng.IPromise<void> {
    if (this.showLogging) {
      console.log("setting partner user...");
    }
    return this.userRetrievalService
      .getUsersInPartner(this.$stateParams.code)
      .then((users: UserManagement.models.UserSearchResult.IUserSearchResult[]) => {
        this.partnerUsers = _.sortBy(users, (user) => {
          return user.username.toLowerCase();
        });
      });
  }
}
